import DocEditContent from './DocEditContent';

export default DocEditContent;
